/**
 * @generated SignedSource<<59818dc489cd44186294a8b6e5783da5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type agentCard_AtlassianConversationAssistantAgent_agentRef$data = {
  readonly authoringTeam: {
    readonly displayName: string | null;
    readonly id: string;
    readonly profileUrl: string | null;
    readonly smallAvatarImageUrl: string | null;
  } | null;
  readonly conversationStarters: ReadonlyArray<string> | null;
  readonly creator: {
    readonly id: string;
  } | null;
  readonly creatorType: string | null;
  readonly deactivated: boolean | null;
  readonly description: string | null;
  readonly externalConfigReference: string | null;
  readonly forgeCreator: string | null;
  readonly icon: string | null;
  readonly id: string;
  readonly identityAccountId: string | null;
  readonly isFavourite: boolean | null;
  readonly name: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"agentCard_AtlassianConversationAssistantAgent_AgentCardContent_agentRef" | "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_agentRef" | "agentVerified_AtlaskitRovoAgentComponents">;
  readonly " $fragmentType": "agentCard_AtlassianConversationAssistantAgent_agentRef";
};
export type agentCard_AtlassianConversationAssistantAgent_agentRef$key = {
  readonly " $data"?: agentCard_AtlassianConversationAssistantAgent_agentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"agentCard_AtlassianConversationAssistantAgent_agentRef">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "enableJiraAgentFields"
    }
  ],
  "kind": "Fragment",
  "name": "agentCard_AtlassianConversationAssistantAgent_agentRef",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "deactivated"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    },
    {
      "kind": "ScalarField",
      "name": "creatorType"
    },
    {
      "kind": "ScalarField",
      "name": "conversationStarters"
    },
    {
      "kind": "ScalarField",
      "name": "identityAccountId"
    },
    {
      "kind": "ScalarField",
      "name": "externalConfigReference"
    },
    {
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "icon"
    },
    {
      "concreteType": "TeamV2",
      "kind": "LinkedField",
      "name": "authoringTeam",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "profileUrl"
        },
        {
          "kind": "ScalarField",
          "name": "displayName"
        },
        {
          "kind": "ScalarField",
          "name": "smallAvatarImageUrl"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "forgeCreator"
    },
    {
      "kind": "FragmentSpread",
      "name": "agentVerified_AtlaskitRovoAgentComponents"
    },
    {
      "kind": "FragmentSpread",
      "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_agentRef"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "enableJiraAgentFields",
          "variableName": "enableJiraAgentFields"
        }
      ],
      "kind": "FragmentSpread",
      "name": "agentCard_AtlassianConversationAssistantAgent_AgentCardContent_agentRef"
    }
  ],
  "type": "AgentStudioAssistant"
};
})();

(node as any).hash = "6a6dea8ccef51693a37cdb11fef7f277";

export default node;
